import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlateCuttingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", {
				style: {},
				children: /* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "M17.8,43.5c-0.2-0.1-0.5-0.1-0.7,0L2.5,51.9c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0c0,0,0,0,0,0v11.9c0,0.3,0.1,0.5,0.3,0.6l14.7,8.5c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.4-0.1c0,0,0,0,0,0 c4-2.3,6.2-5.4,6.4-8.7v-12l0-0.5C24.1,49,21.8,45.9,17.8,43.5z"
				})
			}), /* @__PURE__ */ _jsx("g", {
				style: {},
				children: /* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "M97.5,52.1L56,28.1c-0.2-0.1-0.5-0.1-0.7,0L28.6,43.5c0,0,0,0,0,0c-0.2,0.1-0.3,0.3-0.3,0.5 c0,0,0,0,0,0.1c0,0,0,0,0,0s0,0,0,0V56c0,0.3,0.1,0.5,0.4,0.6c0,0,1.9,1.2,2.7,1.9c-0.8,0.7-1.6,1.3-2.6,1.9c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.1,0.1-0.2,0.3-0.2,0.5V73c0,0.3,0.1,0.5,0.4,0.6l26.9,15.5c0.1,0.1,0.2,0.1,0.4,0.1 c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0,0l7.9-4.6l33.3-19.2c0.2-0.1,0.4-0.4,0.4-0.6v-12C97.9,52.5,97.7,52.2,97.5,52.1z"
				})
			})] }),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M18.1,43c-0.8-0.5-1.8,0.3-2.5,0.7c-1.2,0.7-9.2,5.3-12,6.9c-0.5,0.3-1.2,0.6-1.6,1 c-0.6,0.6-0.5,1.4-0.5,2.2c0,3.1,0,6.2,0,9.3c0,0.9-0.2,1.9,0.7,2.6c0.6,0.5,12.8,7.4,13.9,8c1.3,0.7,2,0.6,3.3-0.3 c3.3-2.2,5.5-5.4,5.5-9.4c0-3.4,0-6.8,0-10.2c0-1.5-0.1-2.8-0.6-4.2C23.1,46.7,20.7,44.5,18.1,43z M2.2,52.5L2.2,52.5L2.2,52.5 C2.2,52.5,2.2,52.5,2.2,52.5z M16.2,70.7l-12-6.9v-8.9l12,6.9V70.7z M18.4,58.9c-0.3,0.2-0.6,0.4-0.9,0.6l-12-6.9l11.9-6.9 c2.8,1.8,5.4,4.7,4.6,8.2C21.6,56,20,57.7,18.4,58.9z M18.8,70.5v-8.7c1.2-0.8,2.4-1.7,3.4-2.8c0,1.6,0,3.3,0,4.9 C22.2,66.6,21,68.8,18.8,70.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M97.8,51.6c-12-7-24.1-13.9-36.1-20.9c-1.7-1-3.4-2.3-5.3-3c-0.8-0.3-1.4-0.1-2.3,0.4 c-0.9,0.5-2.1,1.2-2.7,1.6c-7,4-22.4,12.8-23,13.3c-1.2,0.9-0.7,3.3-0.7,4.7c0,2.3-0.1,8.1,0,8.6c0.3,1.1,1.9,1.6,2.7,2.2 c-1,0.8-2.5,1.2-2.7,2.6c-0.1,0.7,0,7,0,9.4c0,1.2-0.3,2.8,0.8,3.6c0.9,0.6,1.9,1.1,2.8,1.6c7.6,4.4,15.3,8.8,22.9,13.2 c0.9,0.5,1.5,1,2.5,0.5c2-0.9,41.3-23.6,41.6-24.3c0.2-0.5,0.1-1.1,0.1-1.7c0-1.1,0-2.1,0-3.2c0-2.3,0-4.6,0-6.8 C98.5,52.8,98.5,52,97.8,51.6z M30.3,55.2v-8.6c3.2,2.5,4.7,6.5,2,10C31.6,56.1,31,55.7,30.3,55.2z M54.6,86.2l-24.2-14v-8.9 l24.2,14V86.2z M62.5,83.1l-5.3,3.1v-8.9l5.3-3.1V83.1z M63.9,70.4c-3.6-3.1-4.6-7.7-1.4-11.5c2.8-3.4,8.3-4.6,8.9-9.6 c0.1-1.2-0.1-2.3-0.6-3.4c-0.4-0.9-1.3-2.5-2.4-2.5c-1,0-1.6,1.1-1.2,1.9c0.5,1.1,1.5,1.7,1.6,3c0.2,2.3-1.9,3.9-3.6,5 c-2.1,1.2-4,2.8-5.3,4.7c-3.1,4.5-2,9.9,1.8,13.6L55.9,75L31.5,61c3.2-2.4,5.5-6.1,4.6-10.2c-0.6-2.7-2.5-4.9-4.7-6.6l24.2-14 l38.9,22.4L63.9,70.4z M95.8,63.9L65.1,81.6v-8.9L95.8,55V63.9z"
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,3.4c-0.7,0-1.2,0.5-1.2,1.2v1.9c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V4.6 C70.3,4,69.7,3.4,69.1,3.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,25.2c-0.7,0-1.2,0.5-1.2,1.2v4c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-4 C70.3,25.8,69.7,25.2,69.1,25.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,33.2c-0.7,0-1.2,0.5-1.2,1.2v4c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-4 C70.3,33.7,69.7,33.2,69.1,33.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,17.3c-0.7,0-1.2,0.5-1.2,1.2v4c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-4 C70.3,17.8,69.7,17.3,69.1,17.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,9.3c-0.7,0-1.2,0.5-1.2,1.2v4c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-4 C70.3,9.9,69.7,9.3,69.1,9.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M69.1,41.1c-0.7,0-1.2,0.5-1.2,1.2v1.9c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-1.9 C70.3,41.7,69.7,41.1,69.1,41.1z"
		})
	] }) })
});
export default SvgPlateCuttingSm;
